import React, {useImperativeHandle, useState} from "react";
import {
  AButton,
  AIcon,
  AModal,
  APanel,
  APanelBody,
  APanelFooter,
  APanelHeader,
  APanelTitle,
  ATextInput
} from "@cisco-sbg-ui/magna-react";
import {t} from "i18next";
import {useDispatch, useSelector} from "react-redux";
import {saveInvestigation} from "store/features/investigationSlice";
import {selectInvestigationDetailId} from "store/selectors/investigationSelectors";

const SaveInvestigationModal = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const investigationId = useSelector(selectInvestigationDetailId);

  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useImperativeHandle(ref, () => ({
    openModal() {
      setOpen(true);
    }
  }));

  const handleSaveInvestigation = () => {
    dispatch(
      saveInvestigation({
        id: investigationId,
        title: title,
        description: description
      })
    );
    setTitle("");
    setDescription("");
    setOpen(false);
  };

  return (
    <AModal aria-labelledby="modal-title" isOpen={open}>
      <APanel ref={ref} style={{minWidth: "400px"}} type="dialog">
        <APanelHeader>
          <APanelTitle id="modal-title">
            {t("investigationDetail.save.modal.title")}
          </APanelTitle>
          <AButton
            aria-label="Close modal"
            onClick={() => setOpen(false)}
            tertiaryAlt
            icon>
            <AIcon>x</AIcon>
          </AButton>
        </APanelHeader>
        <APanelBody>
          <ATextInput
            className="mb-2"
            medium
            label={t("investigationDetail.save.modal.titleLabel")}
            placeholder="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
          <ATextInput
            className="mb-2"
            medium
            label={t("investigationDetail.save.modal.descriptionLabel")}
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </APanelBody>
        <APanelFooter>
          <AButton secondary className="mr-2" onClick={() => setOpen(false)}>
            {t("investigationDetail.save.modal.cancelBtn")}
          </AButton>
          <AButton
            primary
            onClick={handleSaveInvestigation}
            disabled={!title.length}>
            {t("investigationDetail.save.modal.saveBtn")}
          </AButton>
        </APanelFooter>
      </APanel>
    </AModal>
  );
});

export default SaveInvestigationModal;
